module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/flag-fill-9941ffefbbc1abbaf3e05a3e2d4b6109.svg";